module.exports = __webpack_public_path__ + "static/2-74a8312a4d4f916fc4b63d084fbda35b.png";